import { render, staticRenderFns } from "./withdrawal-view.vue?vue&type=template&id=2e21f9d5&scoped=true&"
import script from "./withdrawal-view.vue?vue&type=script&lang=js&"
export * from "./withdrawal-view.vue?vue&type=script&lang=js&"
import style0 from "./withdrawal-view.vue?vue&type=style&index=0&id=2e21f9d5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e21f9d5",
  null
  
)

export default component.exports